import {Component, HostListener, Input, OnDestroy} from "@angular/core";
import {NbSortingService} from "./nb-sorting.service";


@Component({
  selector: '[nb-sorting-item]',
  template: `
    <ng-content></ng-content>
    <i *ngIf="!!code" class="pull-right fa"
       [ngClass]="{'fa-sort-desc': _sorting === 'desc'
         , 'fa-sort-asc': _sorting === 'asc'
         , 'fa-sort text-muted': _sorting === ''}"></i>
  `
})
export class NbSortingItemComponent implements OnDestroy {
  // 修改箭头方向，传递事件
  _sorting:''|'asc'|'desc' = '';

  @Input()
  code:string;

  @HostListener('click', ['$event'])
  public onToggleSort(event:any):void {
    if (event) {
      event.preventDefault();
    }
    if (this.code) {
      switch (this._sorting) {
        case 'asc':
          this._sorting = 'desc';
          break;
        case 'desc':
          this._sorting = '';
          break;
        default:
          this._sorting = 'asc';
          break;
      }
      this.sortingService.next({code: this.code, sorting: this._sorting});
    }
  }
  private subscription;
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  constructor(
    private sortingService: NbSortingService,
  ){
    this.subscription = this.sortingService.subscribe(ch => this._sorting = ch.code==this.code?this._sorting:'');
  }
}

